import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const orderDataClassName = DataClassName.ORDER
const orderEndpoint = PisaDataClassEndpoint.ORDER

export function pisaOrderDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(orderDataClassName, {
    title: orderDataClassName,
    restApi: createPisaRestApiConfig(orderEndpoint),
    attributes,
  })
}
